export const LOAD_CONTENT = 'hg/checkout/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/checkout/DL_PAGE_LOADED';
export const SET_DATA = 'hg/checkout/SET_DATA';
export const SET_PRODUCT_ID = 'hg/checkout/SET_PRODUCT_ID';



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/checkout/checkout.js
 **/